/* eslint-disable @typescript-eslint/naming-convention */
import type { DefaultCloseIconStyles } from '@/components/utils/TypeUtils';
import { MapToWeight } from '@/components/utils/TypeUtils';

/** These color declarations will be moved to a separate file in the future */
export const TooltipCardColor = '#FFFFFF';
export const TooltipShadowColor = '#8588AC26';
export const sideOverlayShadowColor = '#96969626';
export const halfOverlayShadowColor = '#8588AC40';
export const sideOverlayBorderColor = '#E9E9F0';
export const TooltipContentColor = '#080808';
export const AvatarWithTextIconBg = '#F8FCFF';
export const AvatarWithTextIconShadow = '#337AB71A';
export const AvatarWithTextIconBorder = '#AED1F2';
export const AvatarWithTextIconColor = '#337AB7';
export const modalBgColor = '#FFFFFF';
export const overlayMaskColor = '#686b8e';

export const defaultTooltipStyles: React.CSSProperties = {
  fontSize: '13px',
  fontFamily: 'Geist-Medium',
  color: TooltipCardColor,
  boxShadow: `0px 4px 15px ${TooltipShadowColor}`,
};

export const defaultTooltipContentStyles: React.CSSProperties = {
  color: TooltipContentColor,
  padding: '6px 10px',
};

export const defaultAvatarWithTextIconStyles: React.CSSProperties = {
  width: '54px',
  height: '35px',
  background: `${AvatarWithTextIconBg} 0% 0% no-repeat padding-box`,
  boxShadow: `0px 3px 8px ${AvatarWithTextIconShadow}`,
  border: `1px solid ${AvatarWithTextIconBorder}`,
  borderRadius: '24px',
  fontFamily: 'Geist-Bold',
  color: AvatarWithTextIconColor,
};

export const defaultEmblemStyles: React.CSSProperties = {
  fontSize: '10px',
  fontWeight: MapToWeight.bold,
  fontFamily: 'Geist-Medium',
  boxShadow: 'unset',
};

export const defaultModalStyles: React.CSSProperties = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: modalBgColor,
  padding: '50px',
  zIndex: 1000,
  backgroundClip: 'padding-box',
  border: '1px solid transparent',
};

export const defaultOverlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: overlayMaskColor,
  opacity: 0.5,
  zIndex: 1000,
};

export const defCloseIconWrapperStyles: React.CSSProperties = {
  top: 0,
  position: 'fixed',
  right: 0,
  padding: '23px 23px 0 0',
  cursor: 'pointer',
};

export const halfOverlayCloseWrapStyles: React.CSSProperties = {
  ...defCloseIconWrapperStyles,
  padding: '78px 78px 0 0',
};

export const defaultCloseIconStyles: DefaultCloseIconStyles = {
  height: '14px',
  width: '14px',
};

export const defaultConfirmModalStyles: React.CSSProperties = {
  height: '288px',
  width: '630px',
  outline: 0,
  borderRadius: '20px',
};

export const defFullOverlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: modalBgColor,
  zIndex: 1000,
  border: '1px solid transparent',
  height: '-webkit-fill-available',
  width: '-webkit-fill-available',
};

export const overlayRootEleId = 'overlay-root';

export const defHalfOverlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: modalBgColor,
  zIndex: 1000,
  border: '1px solid transparent',
  height: '-webkit-fill-available',
  width: '-webkit-fill-available',
  margin: '33px 33px 0 33px',
  boxShadow: `0px 6px 15px ${halfOverlayShadowColor}`,
  borderRadius: '20px 20px 0px 0px',
  padding: '30px 35px 0 56px',
};

export const defSideOverlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  right: 0,
  backgroundColor: '#FFF',
  zIndex: 1000,
  height: '-webkit-fill-available',
  width: '524px',
  borderRadius: '12px',
  boxShadow: `0px 0px 8px ${sideOverlayShadowColor}`,
  border: `0.800000011920929px solid ${sideOverlayBorderColor}`,
  padding: '40px 34px 50px 50px',
};

export const defMobCenterOverlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: '40%',
  left: 0,
  backgroundColor: modalBgColor,
  borderColor: '#E2E6F2',
  zIndex: 1001,
  outline: 0,
};

export const basicButtonStyles: React.CSSProperties = {
  borderRadius: '30px',
  letterSpacing: '0px',
  fontSize: '13px',
  fontWeight: 'bold',
  fontFamily: 'Geist-SemiBold',
  padding: '4.5px 11px 4.5px 11px',
};

export const feedBackSubmitBtnStyles: React.CSSProperties = {
  boxShadow: '0px 6px 15px #2626261F',
  border: 'unset',
  color: '#FFFFFF',
  background: '#8066F0',
  borderRadius: '30px',
  padding: '6.5px 15px',
};

export const leftIconButtonStyles: React.CSSProperties = {
  backgroundPosition: '0% 0%',
  backgroundRepeat: 'no-repeat',
  backgroundOrigin: 'padding-box',
  borderRadius: '120px',
  letterSpacing: '0px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontFamily: 'Geist-SemiBold',
  padding: '0px',
  height: '42px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const rightIconButtonStyles: React.CSSProperties = {
  backgroundPosition: '0% 0%',
  backgroundRepeat: 'no-repeat',
  backgroundOrigin: 'padding-box',
  borderRadius: '30px',
  letterSpacing: '0px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '13px',
  fontWeight: 'bold',
  fontFamily: 'Geist-SemiBold',
  opacity: 1,
  padding: '9px 20px',
};

export const buttonDisabledStyles: React.CSSProperties = {
  pointerEvents: 'none',
  opacity: 0.5,
};

export const defaultTagStyles: React.CSSProperties = {
  padding: '5px 6px',
  display: 'inline-flex',
  fontSize: '11px',
  alignItems: 'center',
};

export const sizeTagStyles: React.CSSProperties = {
  padding: '0',
  fontSize: '13px',
  fontFamily: 'Geist-SemiBold',
  width: '32px',
  height: '27px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const defaultTagTextStyles: React.CSSProperties = {
  opacity: 1,
  transition: 'opacity 0.2s ease-out',
  whiteSpace: 'nowrap',
};

export const defaultMultiEmailBoxInputStyles: React.CSSProperties = {
  padding: '0',
  border: '0',
  outline: 'none',
  flexGrow: '1',
  fontSize: '0.75rem',
  marginLeft: '0.313rem',
};

export const defaultMultiEmailBoxInputContainerStyles: React.CSSProperties = {
  flexGrow: '1',
  height: '1.4375rem',
};

export const defaultMultiEmailBoxTagStyles: React.CSSProperties = {
  height: '1.25rem',
  paddingRight: '0rem',
};

export const defaultPrintTypeInfo: React.CSSProperties = {
  backgroundColor: '#EBF5FF',
  color: '#519EEB',
};

export const defaultPrintTypeWarning: React.CSSProperties = {
  backgroundColor: '#FCF1E8',
  color: '#F49B50',
};

export const defaultPrintTypePrimary: React.CSSProperties = {
  backgroundColor: '#F2EFFF',
  color: '#8066F0',
};

export const defaultPrintTypePink: React.CSSProperties = {
  backgroundColor: '#FCEDF7',
  color: '#EB79C5',
};

export const defaultPrintTypeBrandBlue: React.CSSProperties = {
  backgroundColor: '#E8F4FF',
  color: '#337AB7',
};

export const defaultPrintTypeSuccess: React.CSSProperties = {
  backgroundColor: '#E3FFF8',
  color: '#38B896',
};

export const displayNone: React.CSSProperties = {
  display: 'none',
};

export const defaultPromoSuccess: React.CSSProperties = {
  backgroundColor: '#E3FFF8',
  color: '#38B896',
};
